<template>
  <div>
    <div class="row d-flex justify-content-center my-3 container-box-step3">
      <div class="col-md-11 col-sm-12 container-box">
        <div class="col-md-12 col-sm-12">
          <div class="questionnaire-title mb-5 ml-5">
            <strong>Cuestionario</strong>
            <p>Complete toda la información solicitada a continuación.</p>
          </div>
        </div>
        <ValidationObserver ref="formValidator">
          <div class="row">
            <div class="col-md-12">
              <div
                v-for="(item, index) in questionnaire"
                :key="'question-' + index"
              >
                <!-- question section -->
                <div class="col-12 mb-4">
                  <div class="flex-row d-flex border-bottom">
                    <div class="d-flex">
                      <div
                        class="question-section question-order text-center d-flex justify-content-center align-items-center font-weight-bold"
                      >
                        <span class="question-number">
                          {{ getNumberLabel(item.name) }}
                        </span>
                      </div>
                    </div>
                    <div class="col ml-4 flex-grow-1 question-selector-color">
                      <div class="row">
                        <div class="col">
                          <p class="mb-0 ml-n3 question-description bold">
                            <span class="question-title">
                              {{ getFormattedName(item.name) }}
                            </span>
                          </p>
                          <error
                            v-if="item.hasError"
                            variant="no-border ml-n4"
                            message="Campo requerido"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="hasLegendIndicator(item.questions)">
                      <OptionLegendIndicator
                        v-if="!isMobile"
                        :options="catalog.lengends"
                      />
                    </div>
                  </div>
                  <OptionLegendIndicator
                    v-if="hasLegendIndicator(item.questions) && isMobile"
                    :options="catalog.lengends"
                  />
                </div>

                <!-- questions -->
                <div
                  v-for="(question, questionIndex) in item.questions"
                  :key="questionIndex"
                  class="p-4 ml-4 question-selection"
                >
                  <!-- Seleccion Singular Vertical -->
                  <div v-if="isSeleccionSingularVertical(question.mode)">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <custom-radio-button
                        v-model="question.selected"
                        :name="'singularSelectionVertical' + question.id"
                        :options="question.answers"
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </div>

                  <!-- Seleccion Singular Horizontal -->
                  <div v-if="isSeleccionSingularHorizontal(question.mode)">
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <custom-radio-button
                        v-model="question.selected"
                        :name="'singularSelectionHorizontal' + question.id"
                        :options="question.answers"
                        :is-inline="true"
                        :error="errors[0]"
                      />
                    </ValidationProvider>
                  </div>

                  <!-- Seleccion Multiple -->
                  <div v-if="isSeleccionMultiple(question.mode)" class="mb-4">
                    <div class="border-bottom mt-1 mt-n3">
                      <ValidationProvider v-slot="{ errors }" rules="required">
                        <div class="row">
                          <div
                            class="col-md-8 d-flex flex-column justify-content-center"
                          >
                            <span class="questionnaire-question-text">
                              {{ question.numberLabel }} {{ question.text }}
                            </span>
                            <error
                              v-if="item.hasError"
                              variant="no-border ml-0"
                              message="Favor de seleccionar respuesta. (0689)"
                            />
                          </div>
                          <div class="col-md-4 button-selector-wrapper">
                            <custom-radio-button-selector
                              v-model="question.selected"
                              variance="row float-right"
                              :context-id="question.id"
                              :options="sortMultipleAnswer(question.answers)"
                              :error="errors[0]"
                            />
                          </div>
                        </div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row questionnaire-action">
            <div class="col text-center">
              <action-button
                variant="success custom-next-button w-25"
                iright="fa fa-check-circle btn-lg"
                @click="onFinish"
              >
                Finalizar
              </action-button>
            </div>
          </div>

          <error v-if="false" />
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ActionButton, Error } from '@/components/common';
import CustomRadioButton from '../CustomRadioButton';
import CustomRadioButtonSelector from '../CustomRadioButtonSelector';
import OptionLegendIndicator from '../OptionLegendIndicator';
import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
import alertMixin from '@/mixin/alert.mixin';
import questionAnswerMode from '@/utils/constants/questionAnswerMode';

//create module reference
const moduleName = modulesName.welcomePortalModuleName;
const { mapGetters, mapActions, mapMutations } = createNamespacedHelpers(
  moduleName
);

export default {
  name: 'Tab3',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    Error,
    CustomRadioButton,
    CustomRadioButtonSelector,
    OptionLegendIndicator,
  },
  data: () => ({
    catalog: {
      lengends: [
        { id: 1, number: '1', label: 'Nada', color: '#D5B89A' },
        { id: 2, number: '2', label: 'Poco', color: '#DDB3D7' },
        { id: 3, number: '3', label: 'Regular', color: '#FCC9C8' },
        { id: 4, number: '4', label: 'Bastante', color: '#F8EB7F' },
        { id: 5, number: '5', label: 'Mucho', color: '#A3E5B3' },
      ],
    },
    messages: {
      '0690':
        'Es requerido contestar todas las preguntas del cuestionario. Para recibir asistencia en el proceso se puede comunicar con el centro de apoyo al número (787) 585-8855.',
    },
  }),
  computed: {
    ...mapGetters({
      questionnaire: 'getQuestionnaireList',
      studentInfo: 'getInfo',
    }),
    isSeleccionSingularVertical() {
      return (mode) => mode === questionAnswerMode.SeleccionSingularVertical;
    },
    isSeleccionSingularHorizontal() {
      return (mode) => mode === questionAnswerMode.SeleccionMultiple;
    },
    isSeleccionMultiple() {
      return (mode) => mode === questionAnswerMode.SeleccionSingularHorizontal;
    },
    hasLegendIndicator() {
      return (questions) =>
        questions.filter(
          (item) => item.mode === questionAnswerMode.SeleccionSingularHorizontal
        ).length > 0;
    },
    getNumberLabel() {
      return (name) => name.substr(0, name.indexOf('.')).toUpperCase();
    },
    getFormattedName() {
      return (name) => name.substring(name.indexOf('.') + 1).trim();
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    ...mapActions(['saveQuestionnaireAnswers', 'getQuestionnaire']),
    ...mapMutations(['setErrorQuestionnaire']),
    async onFinish() {
      const isCompleted = await this.$refs.formValidator.validate();
      if (isCompleted) {
        const results = this.getMappedResults(this.questionnaire);
        if (results.length > 0 && this.studentInfo) {
          await this.saveQuestionnaireAnswers({
            studentSieId: parseInt(this.studentInfo?.studentSie ?? -1),
            notificationWayId: parseInt(
              this.studentInfo?.selectedNotificationWay?.id ?? -1
            ),
            answers: results,
          });
          this.$emit('complete-tabs', [3, 4]);
        }
      } else {
        this.setErrorQuestionnaire();
        this.ShowToast('Error', this.messages['0690'], 'error');
      }
    },
    sortMultipleAnswer(questions) {
      return _.orderBy(questions, 'id', 'desc');
    },
    getMappedResults(questionnaire) {
      const results = [];
      if (questionnaire.length > 0) {
        for (let item of questionnaire) {
          for (let question of item.questions) {
            if (question.mode == 4) {
              results.push({
                id: parseInt(question.id),
                value: parseInt(question.selected),
              });
            } else {
              results.push({
                id: parseInt(question.id),
                value: parseInt(question.selected?.id),
              });
            }
          }
        }
      }
      return results;
    },
  },
};
</script>

<style scoped lang="scss">
.container-box {
  background: #fafafa;
  border-radius: 5px;
  opacity: 1;
  padding: 30px;

  .questionnaire-title {
    strong {
      text-align: left;
      font: Bold 24px/29px Lato;
      letter-spacing: 0px;
      color: #11291b;
    }
    p {
      text-align: left;
      font: Regular 18px/22px Lato;
      letter-spacing: 0px;
      color: #11291b;
      margin-top: 10px;
    }
  }
}

.question-section.question-order {
  background-color: #ff7058;
  color: white;
}
.question-section {
  width: 60px;
  min-height: 60px;
  border-radius: 5px 5px 0px 0px;
  font: 20px Lato;
}
.question-section.active {
  background-color: #2db782;
}
.question-section {
  background-color: #f2f2f2;
  color: #c9c9c9;
}
.question-answer {
  cursor: pointer;
}
.question-description {
  font: 18px Lato;
  padding-top: 16px;
}

.questionnaire-question-text {
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0px;
  color: #11291b;
}

.custom-radio-content-box {
  ::v-deep .custom-control {
    min-height: 2.5rem !important;
  }
}

.question-selection {
  margin-left: 70px;
}
</style>
